<template>
    <div class="list list-game">
        <p class="name">{{ getItemTitle }}</p>
        <div class="g-select f-fl js-selector">
            <p class="set set-input" @click="toggleSelectOption">
                <input
                    class="input"
                    type="text"
                    :placeholder="placeholder ? placeholder : '请选择'"
                    v-model="searchInput"
                    @blur.prevent="slideUp"
                    @keyup="searchSelectList"
                >
                <i class="ico" :class="showIcon"></i>
            </p>
            <div class="g-selector-option js-selector-option">
                <div class="selector g-scrollbar">
                    <div
                        class="select-item"
                        v-for="(item,index) in searchList"
                        :key="index"
                        @click="pickItem(item)"
                        :title="item.name"
                    >{{ item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.list {
    float: left;
    height: 40px;
    padding-right: 20px;
}

.list .name {
    float: left;
    height: 40px;
    line-height: 38px;
    padding-right: 11px;
    color: #666666;
    white-space: nowrap;
}
.g-select .input {
    width: 100%;
    position: relative;
    height: 40px;
    line-height: 39px;
    border: none;
    font-size: 12px;
    color: #666;
    border-bottom: 1px solid #ebebeb;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.g-select {
    position: relative;
    width: 110px;
}
.ico-down {
    height: 30px;
    width: 30px;
    background-position: -284px -88px;
}
.list-game .g-select .g-selector-option {
    width: 112px;
    overflow: hidden;
}
.g-select .set .ico-down,
.g-select .set .ico-up {
    position: absolute;
    right: -5px;
    top: 5px;
    height: 30px;
    width: 30px;
}
.js-selector-option {
    display: none;
}
.select-item {
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
}
.g-selector-option .selector {
    height: auto;
    max-height: 165px;
}
</style>

<script>
export default {
    name: "select_box.vue",
    props: ["selectList", "selected", "itemTitle", "placeholder"],
    data: function() {
        return {
            searchInput: "",
            originData: this.selectList,
            showIcon: "ico-down",
            isSearching: false
        };
    },
    components: {},
    mounted() {},
    methods: {
        toggleSelectOption() {
            this.isSearching = false;
            let div = $(this.$el).find(".js-selector-option");
            if (div.css("display") == "none") {
                div.slideDown();
                this.showIcon = "ico-up";
                $(this.$el)
                    .find("input")
                    .focus();
            } else {
                div.slideUp();
                this.showIcon = "ico-down";
                $(this.$el)
                    .find("input")
                    .blur();
            }
        },
        slideUp() {
            setTimeout(() => {
                this.isSearching = false;
                let div = $(this.$el).find(".js-selector-option");
                div.slideUp();
                this.showIcon = "ico-down";
            }, 500);
        },
        pickItem(item) {
            this.searchInput = item.name;
            this.selected = item.id;
            this.$emit("update:selected", item.id);
            this.$emit("selectChange", item);
            this.$emit("change", item);
            this.toggleSelectOption();
        },
        searchSelectList() {
            this.isSearching = true;
            let data = [];
            this.selectList.map(item => {
                if (item.name.indexOf(this.searchInput) != -1) {
                    data.push(item);
                }
            });
            this.searchList = data;
        }
    },
    computed: {
        searchList() {
            if (this.isSearching === false) {
                return this.selectList;
            }
            if (this.searchInput == "" || this.searchInput == undefined) {
                this.$emit("update:selected", "");
                return this.selectList;
            } else {
                let data = [];
                this.selectList.map(item => {
                    if (item.name.indexOf(this.searchInput) != -1) {
                        data.push(item);
                    }
                });
                return data;
            }
        },
        getItemTitle() {
            if (typeof this.itemTitle != "undefined") {
                return this.itemTitle;
            }
            return "游戏";
        }
    },
    filters: {},
    watch: {
        selected(n, o) {
            if (!n) {
                this.searchInput = "";
            } else {
                this.selectList.filter(k => {
                    if (k.id == this.selected) {
                        this.searchInput = k.name;
                    }
                });
            }
        }
    }
};
</script>

